import React from "react";
import "./smile-pages.css";

export default function DoesSmilingCauseWrinkles() {
  return (
    <div className="container-box mt-5 mb-5 smile-page">

      <h1>Does Smiling Cause Wrinkles?</h1>

      <p>
        <strong>Smiling itself doesn’t cause wrinkles in a harmful way.</strong> In fact, it’s a natural and
        positive facial movement. However, repeated facial expressions over many years can
        contribute to the formation of <strong>expression lines</strong> (also called dynamic wrinkles).
      </p>

      <hr />

      {/* -------------------- WHY LINES FORM -------------------- */}
      <h3>Why Smiling Creates Expression Lines</h3>

      <ul>
        <li>
          When you smile, muscles around your eyes (like the orbicularis oculi) and mouth contract,
          creating <strong>temporary lines or creases</strong>.
        </li>
        <li>
          Over time, with repeated muscle contractions and natural aging (loss of skin elasticity and
          collagen), these lines can become more permanent.
        </li>
      </ul>

      <p>
        📚 <strong>Source:</strong>
      </p>

      <ul>
        <li>
          Miller & Chang, 2018 — Discusses dynamic wrinkles from facial movements.
        </li>
      </ul>

      {/* -------------------- POSITIVE SIDE -------------------- */}
      <h3>But Here’s the Positive Side</h3>

      <ul>
        <li>
          Smiling boosts mood, reduces stress, and improves overall well-being—
          <strong>all of which are better for your skin and health</strong> than constant frowning or stress.
        </li>
        <li>
          Stress and negative emotions <strong>actually speed up skin aging</strong> by increasing cortisol and
          damaging collagen.
        </li>
      </ul>

      <p>
        📚 <strong>Source:</strong>
      </p>

      <ul>
        <li>
          Lachman et al., 2019 — Chronic stress accelerates skin aging.
        </li>
      </ul>

      {/* -------------------- HOW TO KEEP WRINKLES IN CHECK -------------------- */}
      <h3>How to Keep Wrinkles in Check While Smiling</h3>

      <ul>
        <li>
          Use <strong>sun protection</strong> — UV damage accelerates wrinkle formation.
        </li>
        <li>Keep skin moisturized and nourished.</li>
        <li>
          Practice <strong>facial exercises and good skincare</strong> to maintain elasticity.
        </li>
        <li>
          Embrace the positive: the joy and social benefits of smiling often outweigh the minor
          cosmetic concerns.
        </li>
      </ul>

      <hr />

      {/* -------------------- KEYS TO REMEMBER -------------------- */}
      <h3>🔑 Keys to Remember</h3>

      <p>
        Smiling may contribute to some natural <strong>“expression lines”</strong> over time, but smiling{" "}
        <strong>doesn’t cause harmful wrinkles.</strong> Plus, the health and emotional benefits of smiling far
        outweigh any minimal impact on your skin’s appearance.
      </p>

    </div>
  );
}
